import React from 'react';
import useSubscription from '../../../useSubscription';
import useSubscriptionStatus from '../../../useSubscriptionStatus';
import useQuery from '../../../useQuery';
import {fetchQuery, graphql, useRelayEnvironment} from 'react-relay/hooks';
import {IMPULSE_STATUS_GENERALIZED} from '../../../constants';

const impulseStatusQuery = graphql`
    query impulseStatusSubscriptionImpulseByClaimQuery($claimRequest: ClaimRequestInput) {
        impulseByClaim(request: $claimRequest) {
            id
            claim
            impulseService {
                service {
                    id
                    version
                }
            }
            status
        }
    }
`;

const ImpulseStatusSubscription = ({claim, setImpulseStateDescription}) => {
    const {impulseId} = useQuery();
    const environment = useRelayEnvironment();
    const fetchImpulse = () => {
        fetchQuery(
            environment,  
            impulseStatusQuery, 
            {claimRequest: {value: claim}})
        .subscribe({
            next: (data) => {
                setImpulseStateDescription(IMPULSE_STATUS_GENERALIZED[data.impulseByClaim.status]);
            }
        });
    }
    const payload = React.useMemo(() => ({
        channel: `/impulses/${impulseId}`,
        onNext: () => fetchImpulse(),
        onError: () => {}
    }), [fetchImpulse, impulseId]);
    useSubscription(payload);
    const subscriptionStatus = useSubscriptionStatus();
    React.useEffect(() => {
        if (subscriptionStatus === 0) fetchImpulse();
    }, [subscriptionStatus, fetchImpulse]);

    return null;
};

export default React.memo(ImpulseStatusSubscription);
